export const routes = {
  LOGIN: '/login',
  BUY_TRANSACTIONS: '/txn/buy-txn',
  SEC_MASTER: '/sec-master/sec-master',
  TXN_DETAILS: '/txn-details',
  SELL_TRANSACTIONS: '/txn/sell-txn',
  HOLD_TRANSACTIONS: '/txn/hold-txn',
  HOLD_TRANSACTIONS_HOLDINGS: '/txn/hold-txn/holdings',
  HELP: '/help',
  LOGIN_AUTH: '/login-auth',
  USERS: '/users/users',
  CREATE_CLIENT: '/create-client/create-client',
  DIGITAL_HUB: '/security-services'
};

export const appRoutes = {
  LOGIN: 'login',
  BUY_TRANSACTIONS: 'txn/buy-txn',
  SEC_MASTER: 'sec-master/sec-master',
  TXN_DETAILS: 'txn-details',
  SELL_TRANSACTIONS: 'txn/sell-txn',
  HOLD_TRANSACTIONS: 'txn/hold-txn',
  HOLD_TRANSACTIONS_HOLDINGS: 'txn/hold-txn/holdings',
  HELP: 'help',
  LOGIN_AUTH: 'login-auth',
  USERS: 'users/users',
  CREATE_CLIENT: 'create-client/create-client',
  DIGITAL_HUB: 'security-services'
};